import { ComponentFinder } from '../componentFinder'
import { IteratorProvider } from '../state/itieratorProvider'

interface IElementRendererProps {
    d: any
    screenType: string
    components: any[]
    past?: boolean
}

export const ElementRenderer = ({
    d,
    screenType,
    components,
    past,
}: IElementRendererProps) => {
    /// If item is pending. dont render.
    if (d._pending) {
        return null
    }

    return (
        <IteratorProvider id={d._id}>
            {components
                .filter((c) => !c.visible || c.visible.includes(screenType))
                .map((c, i) => {
                    return (
                        <ComponentFinder
                            key={`finder_${c.componentKey}${i}_${d?._id}`}
                            data={d}
                            renderOptions={c}
                            componentKey={c.componentKey}
                            isInPast={past}
                        />
                    )
                })}
        </IteratorProvider>
    )
}
